var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useCallback } from 'react';
import { propBool, propChildren, propFunc, propId, propNumber, propStr, } from '../../../helpers/custom-prop-types';
import { LoadingSpinner } from '../Loading';
const style = { position: 'relative' };
/* eslint-disable react/button-has-type */
const SubmitButton = (props) => {
    const { buttonType, className, isDisabled, isLoading, onClick, onControlClick, tabIndex, text, value } = props, otherProp = __rest(props, ["buttonType", "className", "isDisabled", "isLoading", "onClick", "onControlClick", "tabIndex", "text", "value"]);
    const onClickEvent = useCallback((e) => {
        if (onClick) {
            e.preventDefault();
            onClick(e);
        }
        if (onControlClick) {
            onControlClick(e);
        }
    }, [onClick, onControlClick]);
    return (_jsxs("button", Object.assign({ className: className, disabled: isDisabled, onClick: onClickEvent, style: style, tabIndex: tabIndex, type: buttonType, value: value }, otherProp, { children: [text, isLoading && (_jsx("div", Object.assign({ className: 'action-loader' }, { children: _jsx("div", Object.assign({ className: 'loading' }, { children: _jsx(LoadingSpinner, { isColorful: false }) })) })))] })));
};
SubmitButton.propTypes = {
    buttonType: propStr(),
    className: propStr(),
    isDisabled: propBool().isRequired,
    isLoading: propBool().isRequired,
    onClick: propFunc(),
    onControlClick: propFunc(),
    tabIndex: propNumber(),
    text: propChildren().isRequired,
    value: propId(),
};
SubmitButton.defaultProps = {
    buttonType: 'submit',
    className: 'btn btn-primary wide',
    onClick: null,
    onControlClick: null,
    tabIndex: 0,
    value: undefined,
};
export default SubmitButton;
